import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faLayerGroup,
} from "@fortawesome/free-solid-svg-icons";

const MobileCard = ({
  rowData,
  categorized,
  isExpanded,
  onExpandClick,
  hasExpansion,
  selectionBody,
  expansionLabel,
  t,
}) => {
  const [showMore, setShowMore] = useState(false);

  const renderCellValue = (col, row) => {
    if (col.mobileBody) {
      try {
        return col.mobileBody(row);
      } catch {
        return row[col.field] ?? "";
      }
    }
    if (col.body) {
      try {
        return col.body(row);
      } catch {
        return row[col.field] ?? "";
      }
    }
    return row[col.field] ?? "";
  };

  const { title, badges, primary, secondary, actions, financial } = categorized;

  // All priority-1 fields (identity, dates, financial, other) in one unified grid
  const primaryFields = primary.filter((c) => c.group !== "financial");
  const allBodyFields = [...primaryFields, ...financial];

  return (
    <div className={`mobile-card ${isExpanded ? "mobile-card--expanded" : ""}`}>
      {/* Card Header */}
      <div className="mobile-card__header">
        <div className="mobile-card__header-top">
          {selectionBody && (
            <div className="mobile-card__select">
              {selectionBody(rowData)}
            </div>
          )}

          <div className="mobile-card__header-content">
            {title && (
              <div className="mobile-card__title">
                {renderCellValue(title, rowData)}
              </div>
            )}
            {badges.length > 0 && (
              <div className="mobile-card__badges">
                {badges.map((col) => (
                  <span key={col.field} className="mobile-card__badge">
                    {renderCellValue(col, rowData)}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Unified fields grid: identity, dates, financial, other */}
      {allBodyFields.length > 0 && (
        <div className="mobile-card__body">
          {allBodyFields.map((col) => (
            <div
              key={col.field}
              className={`mobile-card__field${col.group === "financial" ? " mobile-card__field--financial" : ""}`}
            >
              <span className="mobile-card__field-label">{col.header}</span>
              <span className="mobile-card__field-value">
                {renderCellValue(col, rowData)}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* Show More / Less */}
      {secondary.length > 0 && (
        <>
          <button
            className="mobile-card__toggle"
            onClick={() => setShowMore(!showMore)}
          >
            <FontAwesomeIcon icon={showMore ? faChevronUp : faChevronDown} />
            <span>
              {showMore
                ? t("common.showLess", "Show Less")
                : `${t("common.showMore", "Show More")} (${secondary.length})`}
            </span>
          </button>
          {showMore && (
            <div className="mobile-card__secondary">
              {secondary.map((col) => (
                <div key={col.field} className="mobile-card__field">
                  <span className="mobile-card__field-label">{col.header}</span>
                  <span className="mobile-card__field-value">
                    {renderCellValue(col, rowData)}
                  </span>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* Footer: actions + details button */}
      <div className="mobile-card__footer">
        {actions.length > 0 && (
          <div className="mobile-card__actions">
            {actions.map((col) => (
              <div key={col.field} className="mobile-card__action-item">
                {renderCellValue(col, rowData)}
              </div>
            ))}
          </div>
        )}

        {hasExpansion && (
          <button
            className={`mobile-card__expand-btn ${isExpanded ? "mobile-card__expand-btn--active" : ""}`}
            onClick={() => onExpandClick(rowData)}
          >
            <FontAwesomeIcon icon={faLayerGroup} />
            <span>{expansionLabel || t("common.details", "Details")}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default MobileCard;
